import { FormGroup } from 'reactstrap';

function CustomFormGroup({ children, ...rest }) {
  return <FormGroup {...rest}>{children}</FormGroup>;
}

export default CustomFormGroup;
